// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__3vkFC","title":"Style_title__e9sK9","detail":"Style_detail__GcX3a","options":"Style_options__34uBt"};